<div data-testid="employee-mgmt-page" class="p-4 flex-table-page">
  <h2 class="text-2xl font-semibold text-gray-800 mb-3 flex-table-header">
    {{ "employee.management.title" | translate }}
  </h2>

  <app-search-form
    data-testid="employee-mgmt-search-form"
    [searchFormat]="searchFormConfig()"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions" class="flex items-center gap-2">
      <app-button
        [testId]="'employee-mgmt-column-config-btn'"
        type="success"
        [outlined]="true"
        icon="view_column"
        (emitOnClick)="onColumnConfigClick($event)"
      ></app-button>
      @if (canEdit()) {
        <app-button
          [testId]="'employee-mgmt-unassign-roles-btn'"
          type="danger"
          [outlined]="true"
          [label]="
            'configuration.user_roles_assignment.actions.unassign_roles'
              | translate
          "
          [disabled]="selectedUsers().length === 0"
          (emitOnClick)="onUnassignRoles()"
        ></app-button>
        <app-button
          [testId]="'employee-mgmt-assign-roles-btn'"
          type="info"
          [label]="
            'configuration.user_roles_assignment.actions.assign_roles'
              | translate
          "
          [disabled]="selectedUsers().length === 0"
          (emitOnClick)="onAssignRoles()"
        ></app-button>
      }
    </div>
  </app-search-form>

  <div class="flex-table-section">
    <advanced-data-table
      data-testid="employee-mgmt-table"
      #advancedTable
      [dataSource]="users()"
      [defaultColumns]="defaultColumns()"
      [flexibleColumns]="flexibleColumns()"
      [loading]="loading()"
      [rows]="searchParams().size"
      [first]="searchParams().page * searchParams().size"
      [totalRecords]="totalRecords()"
      [hasCheckColumn]="true"
      [showInternalColumnConfigButton]="false"
      [sortField]="sortField()"
      [sortOrder]="sortOrder()"
      [selection]="selectedUsers()"
      scrollHeight="flex"
      (pageChange)="onPageChange($event)"
      (sortChange)="onSortChange($event)"
      (selectionChange)="onSelectionChange($event)"
      class="w-full"
    >
    </advanced-data-table>
  </div>
</div>

<p-toast data-testid="employee-mgmt-toast"></p-toast>
